module.exports = __webpack_public_path__ + "img/StreamAnomalyDetection.b3fa62c8.png";